package uz.ferro.erp.feature.auth.model

import kotlinx.serialization.Serializable

@Serializable
data class EmailAuthConfirmBody(
    var email: String?,
    val code: String?
)